import { FlexBox, Text } from '@fable/components'
import { css, cx } from '@fable/theme'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'

export interface ChartLegendItem {
  color: string
  label: string
}

export interface ChartLegendProps {
  className?: string
  items: ChartLegendItem[]
}

export const ChartLegend = ({ items, className = '' }: ChartLegendProps) => {
  const theme = useStatsTheme((s) => s.theme)

  return (
    <FlexBox
      className={cx(
        css`
          width: 100%;
          gap: 8px 5%;
          flex-wrap: wrap;
        `,
        className
      )}
      alignItems="center"
    >
      {items.map(({ color, label }) => (
        <FlexBox
          key={label}
          className={css`
            gap: 4px;
          `}
          alignItems="center"
        >
          <span
            className={css`
              display: block;
              width: 12px;
              height: 12px;
              background-color: ${color};
              border-radius: 4px;
            `}
          />
          <Text
            className={css`
              font-size: 10px;
              line-height: 12px;
              letter-spacing: -0.2px;
            `}
            type="body"
            weight="500"
            color={theme.colors.section.legend.text}
          >
            {label}
          </Text>
        </FlexBox>
      ))}
    </FlexBox>
  )
}
